import { render, staticRenderFns } from "./LookStudent.vue?vue&type=template&id=26b795a0&scoped=true"
import script from "./LookStudent.vue?vue&type=script&lang=js"
export * from "./LookStudent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../Vue/course_selecttion_v3/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26b795a0",
  null
  
)

export default component.exports